export interface Brand {
  id: number
  name: string
  slug: string
  programName: string
  color: string
  buttonColor: string
  buttonTextColor: string
  logo: string
  formLogo: string
  // Dashboard-specific properties
  dashboardLogo: string
  adminLogo: string
  sidebarBg: string
  sidebarActiveBg: string
  accentColor: string
  hoverColor: string
  fontFamily?: string
}

/* eslint-disable @typescript-eslint/no-var-requires */
export const BRANDS: Brand[] = [
  {
    id: 1,
    name: 'Continental',
    slug: 'continental',
    color: '#ffa600',
    buttonColor: '#ffa600',
    buttonTextColor: '#333',
    programName: 'TOTAL CONFIDENCE PLAN',
    logo: require('@/assets/continental-logo.png'),
    formLogo: require('@/assets/continental-form.png'),
    // Dashboard branding
    dashboardLogo: require('@/assets/continental-form.png'),
    adminLogo: require('@/assets/continental-form.png'),
    sidebarBg: '#ffa600',
    sidebarActiveBg: '#c88200',
    accentColor: '#c88200',
    hoverColor: '#ffb733',
    fontFamily: 'Continental Stag Sans, Poppins, sans-serif',
  },
  {
    id: 2,
    name: 'Falken',
    slug: 'falken',
    color: '#1c6cc4',
    buttonColor: '#e60045',
    buttonTextColor: '#fff',
    programName: 'Road Hazard Ready',
    logo: require('@/assets/falken-logo.png'),
    formLogo: require('@/assets/falken-form.png'),
    // Dashboard branding
    dashboardLogo: require('@/assets/falken-form.png'),
    adminLogo: require('@/assets/falken-form.png'),
    sidebarBg: '#1c6cc4',
    sidebarActiveBg: '#002853',
    accentColor: '#e60045',
    hoverColor: '#f01055',
  }
]
/* eslint-enable @typescript-eslint/no-var-requires */

export const getBrandBySlug = (slug: string): Brand | undefined => {
  return BRANDS.find(brand => brand.slug === slug)
}

export const getBrandById = (id: number): Brand | undefined => {
  return BRANDS.find(brand => brand.id === id)
}